/**
 * Generic modal-dialog open/close helpers — Phase 3.2.c.
 *
 * Pulled out of admin.js so view modules can `import { openDialog,
 * closeDialog } from '../../src/lib/dialog.js'` directly instead of
 * receiving them via `configure({helpers})` injection. Used by every
 * cluster (installations, tickets, hr, products, users, ...).
 *
 * The `modalStack` tracks open dialogs so we can keep the toast layer
 * raised above whichever modal is currently on top — `ensureToastLayer`
 * is called on each open/close to refresh the z-stack ordering.
 */

import { ensureToastLayer } from '../../js/notifications.js';

const modalStack = [];

export function openDialog(dialogEl) {
  if (!dialogEl) return;
  const target = dialogEl;
  try {
    if (typeof target.showModal === 'function') {
      target.showModal();
    } else {
      target.open = true;
    }
  } catch {
    target.open = true;
  }
  if (!modalStack.includes(target)) {
    modalStack.push(target);
    target.addEventListener('close', () => {
      const idx = modalStack.indexOf(target);
      if (idx >= 0) modalStack.splice(idx, 1);
    }, { once: true });
  }
  ensureToastLayer();
}

export function closeDialog(dialogEl) {
  if (!dialogEl) return;
  try { dialogEl.close(); }
  catch { dialogEl.open = false; }
  const idx = modalStack.indexOf(dialogEl);
  if (idx >= 0) modalStack.splice(idx, 1);
  ensureToastLayer();
}
